import React, { useState } from 'react'
import styled from 'styled-components'
import { TableCell, Text } from 'grommet'
import { sortArrows, sortUpArrow, sortDownArrow } from '@assets/images'

export default ({ col, changeOrderBy, orderBy }) => {
    const isFilterSelected = orderBy[col.property]
    const [sortIsAscending, setSortIsAscending] = useState(false)
    const [cancelSortCycle, setCancelSortCycle] = useState(0)
    const sortBy = () => {
        cancelSortCycle === 2
            ? setCancelSortCycle(0)
            : setCancelSortCycle(cancelSortCycle + 1)
        if (col.sortable) {
            cancelSortCycle === 2
                ? changeOrderBy({})
                : changeOrderBy({
                      [col.property]: sortIsAscending ? 'asc' : 'desc',
                  })
            setSortIsAscending(!sortIsAscending)
        }
    }

    const getSortIcon = () => {
        if (isFilterSelected) {
            if (sortIsAscending) {
                return sortDownArrow
            }
            return sortUpArrow
        }
        return sortArrows
    }

    return (
        <TableHeaderCell
            minWidth={col.minWidth}
            scope="col"
            plain={false}
            align={col.align}
            sortable={col.sortable}
            changeOrderBy={changeOrderBy}
            onClick={sortBy}
        >
            <HeaderLabelText selected={isFilterSelected}>
                {col.label}
                {col.sortable && (
                <SortableIcon
                    src={getSortIcon()}
                    withOpacity={!isFilterSelected}
                />
            )}
            </HeaderLabelText>
           
        </TableHeaderCell>
    )
}

const TableHeaderCell = styled(TableCell)`
    border: 0px;
    font-size: 14px;
    min-width: ${(p) => (p.minWidth ? p.minWidth : '100px')};
    cursor: ${(p) => (p.sortable ? 'pointer' : 'initial')};
    flex-direction: row;
    align-items: center;
`

const HeaderLabelText = styled(Text)`
    color: #ffffff;
    font-size: 14px;
    font-weight: bold;
    white-space: nowrap;
    color: ${(p) => (p.selected ? 'black' : 'white')};
`

const SortableIcon = styled.img.attrs((p) => ({ src: p.src }))`
    width: 16px;
    margin-bottom: -4px;
    opacity: ${(p) => (p.withOpacity ? 0.5 : 1)};
`
